import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

/**
 * 播放器入口
 *
 * @author xiaojingge
 */

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />,
);
